import React from 'react';
import PropTypes from 'prop-types';
import { Button, Box, DialogTitle, DialogContent, DialogActions, Typography } from '@material-ui/core';

import { AlertWrapper, DialogButton } from 'src/components';
import { useFetchStatus } from 'src/hooks';


const LinkCodeRemoveDialog = ({ actions }) => {

  const { fetchStatus, errorMessage, handleConfirm, hasError } = useFetchStatus({
    confirmFn: () => actions.deleteLinkCode(),
    closeFn: actions.closeDialog,
  });

  return (
    <>
      <DialogTitle id="form-dialog-title">
        Eliminar código de vinculación
      </DialogTitle>
      <DialogContent>
        <Box p={1}>
          <Typography variant="body1" color="textPrimary">
            Si eliminas este código, no podrá ser utilizado por la empresa de capture para realizar la vinculación de datos
          </Typography>
          <Box py={2} />
          <Typography variant="body1" color="textPrimary">
            ¿Realmente deseas eliminar el código de vinculación?
          </Typography>
          {hasError && <><Box py={1}><AlertWrapper severity="error">{errorMessage}</AlertWrapper></Box></>}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={actions.closeDialog}>Cancelar</Button>
        <DialogButton fetchStatus={fetchStatus} onClick={handleConfirm} color='primary'>Si, eliminar</DialogButton>
      </DialogActions>
    </>
  );
};

LinkCodeRemoveDialog.propTypes = {
  actions: PropTypes.object,
};


export {
  LinkCodeRemoveDialog,
};
